import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["totalLoanAmount", "mortgageType", "netRate"],
  _excluded2 = ["mortgage-type"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _entriesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/entries";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapState } from "vuex";
import { SUBMIT_TO_LENDER, PRINT_DOCUMENT_FORM } from "../../../../store/lender-submit-actions";
import { CHANGE_MORTGAGE_LENDER } from "../../../../store/application-actions";
import DirectToLenderAppSummary from "../direct-to-lender-app-summary";
import ApplicationsTable from "./applications-table";
import SubmissionBlock from "./submission-block";
import SubmissionHistoryTable from "./submission-history-table";
import LenderNote from "./lender-note";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import Err from "../../../../../../../../routes/error";
import { capitalize } from "lodash";
import { MISSING_FILOGIX_DETAILS_FOR_SUBMISSION } from "@Broker/@Modules/settings/store/settings-getters";
import { CURRENT_APPLICATION } from "../../../../store/application-getters";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS } from "@Broker/@Modules/main/store/account/account-getters";
import { LOAD_PERSONAL_DETAILS } from "@Broker/@Modules/main/store/account/account-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LenderSubmit",
  components: {
    DirectToLenderAppSummary,
    ApplicationsTable,
    SubmissionHistoryTable,
    SubmissionBlock,
    LenderNote
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedMortgageType: "",
      mortgageTypeIndexAppsTable: 1,
      mortgageTypeIndexSubmissionHistory: 6,
      currentLenderNote: null,
      printingPDF: false,
      mortgageTypeMapping: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("ApplicationStore", ["calculatedValues"])), mapGetters("ApplicationStore", [CURRENT_APPLICATION])), mapGetters("SettingsStore", [MISSING_FILOGIX_DETAILS_FOR_SUBMISSION])), mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS])), {}, {
    mortgages() {
      const {
        mortgageValues
      } = this.calculatedValues;
      return _mapInstanceProperty(mortgageValues).call(mortgageValues, _ref => {
        var _submissionDetails$mo, _submissionDetails$mo2;
        let {
            totalLoanAmount,
            mortgageType,
            netRate
          } = _ref,
          res = _objectWithoutProperties(_ref, _excluded);
        const mortgageSubmissionDetails = this.CURRENT_APPLICATION["submission-details"];
        const submissionDetails = _reduceInstanceProperty(mortgageSubmissionDetails).call(mortgageSubmissionDetails, (acc, _ref2) => {
          let {
              "submission-details": {
                "mortgage-type": mortgageType
              }
            } = _ref2,
            values = _objectWithoutProperties(_ref2["submission-details"], _excluded2);
          acc[mortgageType] = values;
          return acc;
        }, {});
        const lineOfBusiness = (_submissionDetails$mo = (_submissionDetails$mo2 = submissionDetails[mortgageType]) == null ? void 0 : _submissionDetails$mo2["line-of-business"]) != null ? _submissionDetails$mo : "";
        return _objectSpread({
          totalLoanAmount,
          mortgageType,
          netRate,
          lineOfBusiness: capitalize(lineOfBusiness)
        }, res);
      });
    },
    selectedMortgage: {
      get() {
        if (!this.selectedMortgageType) return this.mortgages[0] || {
          totalLoanAmount: 0,
          netRate: 0,
          lineOfBusiness: ""
        };
        return this.mortgages[this.mortgageTypeMapping[this.selectedMortgageType]];
      },
      set(value) {
        this.selectedMortgageType = value.mortgageType || value;
      }
    },
    missingFilogixDetailsForSubmission() {
      return this.MISSING_FILOGIX_DETAILS_FOR_SUBMISSION;
    },
    accessRights() {
      return this.CURRENT_ACCOUNT_ACCESS_RIGHTS;
    }
  }),
  async mounted() {
    await this.LOAD_PERSONAL_DETAILS();
  },
  created() {
    this.createMortgageTypeMapping();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [SUBMIT_TO_LENDER, PRINT_DOCUMENT_FORM, CHANGE_MORTGAGE_LENDER])), mapActions("AccountStore", [LOAD_PERSONAL_DETAILS])), {}, {
    setSelectedMortgage({
      mortgageType
    }) {
      this.selectedMortgage = mortgageType;
    },
    createMortgageTypeMapping() {
      for (const [index, mortgage] of _entriesInstanceProperty(_context = this.mortgages).call(_context)) {
        var _context;
        this.mortgageTypeMapping[mortgage.mortgageType] = index;
      }
    },
    async handleLenderSubmit(lenderSubmitData) {
      const {
        mortgageType
      } = this.selectedMortgage || {};
      const {
        submitButton
      } = this.$refs.submissionBlock.$refs;
      $(submitButton).animateButton().animate("start");
      try {
        const {
          applicationId,
          clientUsername,
          agentUsername
        } = this;
        const {
          submissionId
        } = await this.SUBMIT_TO_LENDER({
          lenderSubmitData: _objectSpread(_objectSpread({}, lenderSubmitData), {}, {
            mortgageType
          }),
          applicationId,
          clientUsername,
          agentUsername
        });
        if (lenderSubmitData.submissionMethod === "manual") {
          const forms = [{
            type: "mortgageSummary",
            province: "FEDERAL",
            mortgage: mortgageType
          }];
          const payload = {
            applicationId,
            clientUsername,
            forms,
            submissionId
          };
          await this.PRINT_DOCUMENT_FORM(payload);
        }
        this.$refs.submissionBlock.clearNote();
        await $(submitButton).animateButton().animate("finish");

        //rerender submit button to reset its state
        this.$refs.submissionBlock.showButton = false;
        this.$nextTick(() => {
          this.$refs.submissionBlock.showButton = true;
        });
      } catch (e) {
        $(submitButton).animateButton().animate("finish", "failed");
      }
      this.$refs.submissionTable.reloadSubmissionHistory();
    },
    updateLenderName(lenderName) {
      const {
        mortgageType
      } = this.selectedMortgage;
      this.CHANGE_MORTGAGE_LENDER({
        mortgageType,
        lenderName
      });
      this.$emit("direct-save");
    },
    async handlePrintAppPDF({
      submissionId,
      mortgageType
    }) {
      try {
        this.printingPDF = true;
        const forms = [{
          type: "mortgageApplication",
          province: "FEDERAL",
          mortgage: mortgageType
        }];
        const payload = {
          clientUsername: this.clientUsername,
          applicationId: this.applicationId,
          forms,
          submissionId
        };
        await this.PRINT_DOCUMENT_FORM(payload);
      } catch (e) {
        Err.handle(e);
      } finally {
        this.printingPDF = false;
      }
    },
    handleShowLenderNote({
      lenderNote
    }) {
      this.currentLenderNote = lenderNote;
      showBModal("lender-note-modal", this.currentLenderNote, this);
    }
  })
});